export function Switch({ checked, onChange, disabled, label }: { checked: boolean; onChange: (checked: boolean) => void; disabled?: boolean; label?: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40 disabled:opacity-50 ${checked ? 'bg-brand-600' : 'border border-border bg-canvas'}`}
    >
      <span className={`inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform duration-150 ${checked ? 'translate-x-6' : 'translate-x-1'}`} />
    </button>
  );
}
